<template>
  <div class="wrapper" v-show="loading">
    <div class="sub-wrapper">
      <Loader />
    </div>
  </div>
  <div
    v-if="gateway_timeout > 5"
    class="alert alert-custom alert-indicator-left indicator-danger"
    style="margin-top: 20px"
    role="alert"
  >
    <div class="alert-content">
      <span class="alert-text" style="font-size: large">
        There appears to be an issue with our services, we are trying to resolve
        the issue as quickly as possible.
      </span>
    </div>
  </div>
  <div class="p-v-sm m-b-md" v-if="!loading">
    <div class="row">
      <h4 class="section-heading m-b-sm">
        {{ $t(data_heading.heading).toUpperCase() }}
      </h4>
      <div class="form-group justify-content-between gap-3 d-flex row m-b-sm form-heading">
        <div class="col-xl-6">
          <select
            v-model="selectedTime"
            class="form-select"
            @change="refreshData"
            style="max-width: 200px;"
          >
            <option value="day">{{ $t("dashboard.todays_data") }}</option>
            <option value="week">{{ $t("dashboard.weeks_data") }}</option>
            <option value="month" selected>{{ $t("dashboard.months_data") }}</option>
            <option value="year">{{ $t("dashboard.years_data") }}</option>
          </select>

          <div class="btn-group" style="margin-top: 10px;" role="group" aria-label="Time navigation">
            <button class="btn btn-sm btn-secondary" @click="adjustTimeFrameRelative(+1)">
              {{ previousTimeframeRelative }} &lt;
            </button>
            <button class="btn btn-dark" disabled>{{ currentTimeframeRelative }}</button>
            <button class="btn btn-sm btn-secondary" v-show="timeframeRelative > 0" @click="adjustTimeFrameRelative(-1)">
              &gt; {{ nextTimeframeRelative }}
            </button>
          </div>
        </div>

        <div class="col-xl-3">
          <div class="form-group">
            <div class="row">
              <div class="col-12">
                <Multiselect
                  v-model="site"
                  :class="{ 'multi-dark': $store.state.auth.status.dark }"
                  mode="single"
                  placeholder="Select a site"
                  :close-on-select="false"
                  :searchable="true"
                  :create-option="true"
                  :multiple="false"
                  :options="sites"
                  label="name"
                  track-by="id"
                  name="site"
                  @select="(value) => loadData(value)"
                  @remove="removeSite"
                />
                <button
                  class="col-12 btn btn-primary space-between"
                  v-show="site != null"
                  @click="resetSiteFilter()"
                >
                  Show all
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Select site group -->
        <div v-if="siteGroups.length > 0" class="col-xl-3">
          <div class="form-group">
            <label for="selectSite" class="form-label"> Select Site Group </label>
            <Multiselect
              v-model="siteGroup"
              :class="{ 'multi-dark': $store.state.auth.status.dark }"
              mode="single"
              placeholder="Select a site group"
              :close-on-select="false"
              :searchable="true"
              :create-option="true"
              :multiple="false"
              :options="siteGroups"
              label="name"
              track-by="id"
              name="sitegroup"
              @select="(value) => loadSiteGroupData(value)"
              @remove="removeSiteGroup"
            />
          </div>
        </div>
      </div>  
    </div>

    <div class="row">
      <div class="col-4">
        <div class="card widget widget-stats">
          <div class="card-body">
            <div class="widget-stats-container d-flex">
              <div class="widget-stats-content flex-fill">
                <span class="widget-stats-title">Total Faces Seen</span>
                <span class="widget-stats-amount">{{
                  totalFaces.toLocaleString()
                }}</span>
                <span class="widget-stats-info">{{ timeframeDisplay }}</span>
              </div>
              <!-- <div class="widget-stats-indicator widget-stats-indicator-negative align-self-start">
                    <i class="material-icons">keyboard_arrow_down</i> 4%
                </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card widget widget-stats">
          <div class="card-body">
            <div class="widget-stats-container d-flex">
              <div class="widget-stats-content flex-fill">
                <span class="widget-stats-title">Busiest Day</span>
                <span class="widget-stats-amount">{{ busiestDay.date }}</span>
                <span class="widget-stats-info"
                  >{{ busiestDay.total.toLocaleString() }} Faces</span
                >
              </div>
              <!-- <div class="widget-stats-indicator widget-stats-indicator-negative align-self-start">
                    <i class="material-icons">keyboard_arrow_down</i> 4%
                </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card widget widget-stats">
          <div class="card-body">
            <div class="widget-stats-container d-flex">
              <div class="widget-stats-content flex-fill">
                <span class="widget-stats-title">Busiest Hour</span>
                <span class="widget-stats-amount">{{ busiestHour.hour }}</span>
                <span class="widget-stats-info"
                  >{{ busiestHour.total.toLocaleString() }} Faces</span
                >
              </div>
              <!-- <div class="widget-stats-indicator widget-stats-indicator-negative align-self-start">
                    <i class="material-icons">keyboard_arrow_down</i> 4%
                </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="table-responsive">
        <h5>Bandings <span class="text-muted">| {{ bandingsDateDisplay }}</span></h5>

        <table class="table table-borderless">
          <thead>
            <tr>
              <th>Site</th>
              <th>Average Daily Faces</th>
              <th>Number of Alerts</th>
              <th>Current Band</th>
              <th>Cost per Month</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="site in data.sites">
              <td>{{ site.name }}</td>
              <td>{{ site.average }}</td>
              <td>{{ site.alerts }}</td>
              <td>{{ site.band }}</td>
              <td>£{{ site.charge }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
import dashboardServices from "../../../services/dashboard.services";
import { Multiselect } from "vue-multiselect";
import clientService from "../../../services/client.service";
import axios from "axios";
import authHeader from "../../../services/auth-header";
import { DateTime } from "luxon";
import Loader from "./Loader.vue";

export default {
  name: "FaceDashboard",
  components: {
    Multiselect,
    Loader,
  },
  data() {
    return {
      loading: true,
      data: {},
      site: null,
      sites: [],
      siteGroup: null,
      siteGroups: [],
      selectedSiteGroup: null,
      autoSelectedSite: false,
      gateway_timeout: 0,
      selectedTime: "month",
      timeframeRelative: 0,
      startDate: null,
      endDate: null,
    };
  },
  mounted() {
    this.setDates();
    this.getSiteGroups();
    this.getSites();
    this.loadData(null, null);
  },
  methods: {
    getSites() {
      clientService
        .getClientSites(
          this.$store.state.auth.user.selectedClient,
          false,
          this.siteGroup,
          5
        )
        .then((response) => {
          response.data = response.data.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          response.data.forEach((site) => {
            if (site.customer_reference) {
              site.name = `(${site.customer_reference}) ${site.name}`;
            }
          });
          this.sites = response.data;
          if (this.sites.length > 0 && this.sites.length < 2) {
            this.site = this.sites[0];
            this.autoSelectedSite = true;
            this.$emit('site-selected', this.sites[0].id, false);
          }
        })
        .catch((error) => {
          this.$error(this.$t("sites.site_load_error"), error);
          if (error.response.status === 504) {
            this.gateway_timeout += 1;
          }
        });
    },
    getSiteGroups() {
      clientService
        .getClientSiteGroups(this.$store.state.auth.user.selectedClient)
        .then((response) => {
          this.siteGroups = response.data;
        })
        .catch((error) => {
          this.$error(this.$t("sites.site_load_error"), error);
          if (error.response.status === 504) {
            this.gateway_timeout += 1;
          }
        });
    },
    loadSiteGroupData(value) {
      this.siteGroup = value.id;
      this.getSites();
      this.loadData(this.site, this.siteGroup);
    },
    removeSiteGroup() {
      this.siteGroup = null;
      this.getSites();
      this.loadData(this.site, null);
    },
    resetSiteFilter() {
      this.site = -1;
      this.site = null;
      this.siteGroup = null;
      this.loadData(null, this.siteGroup);
    },
    loadData(site, siteGroup) {
      if (site) {
        this.$emit('site-selected', site.id, !this.autoSelectedSite);
      }
      axios
        .get(`https://api.varsanpr.com/customer/face-portal/dashboard`, {
          headers: authHeader(),
          params: {
            client_id: this.$store.state.auth.user.selectedClient,
            site_id: site ? site.id : null,
            site_group_id: siteGroup ? siteGroup : null,
            start_date: this.startDate.toFormat("yyyy-MM-dd"),
            end_date: this.endDate.toFormat("yyyy-MM-dd"),
          },
        })
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          this.$error("Failed to load data", error);
          if (error.response.status === 504) {
            this.gateway_timeout += 1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refreshData() {
      this.timeframeRelative = 0; 
      this.setDates();
      this.loadData(this.site, this.siteGroup);
    },
    adjustTimeFrameRelative(adjustment) {
      this.timeframeRelative += adjustment; 
      this.setDates();
      this.loadData(this.site, this.siteGroup);
    },
    setDates() {
      const today = DateTime.local();

      switch (this.selectedTime) {
        case "day":
          this.startDate = today.minus({ days: this.timeframeRelative }).startOf('day');
          this.endDate = today.minus({ days: this.timeframeRelative }).endOf('day');
          break;
        case "week":
          this.startDate = today.minus({ weeks: this.timeframeRelative }).startOf('week');
          this.endDate = today.minus({ weeks: this.timeframeRelative }).endOf('week');
          break;
        case "month":
          this.startDate = today.minus({ months: this.timeframeRelative }).startOf('month');
          this.endDate = today.minus({ months: this.timeframeRelative }).endOf('month');
          break;
        case "year":
          this.startDate = today.minus({ years: this.timeframeRelative }).startOf('year');
          this.endDate = today.minus({ years: this.timeframeRelative }).endOf('year');
          break;
      }
    },
  },
  computed: {
    totalFaces: function () {
      let total = 0;
      for (let key in this.data.faces) {
        if (Object.hasOwnProperty.call(this.data.faces, key)) {
          let element = this.data.faces[key];
          for (let key2 in element) {
            if (Object.hasOwnProperty.call(element, key2)) {
              let element2 = element[key2];
              total += element2;
            }
          }
        }
      }
      return total;
    },
    busiestDay: function () {
      let busiest = {
        date: null,
        total: 0,
      };
      for (let key in this.data.faces) {
        if (Object.hasOwnProperty.call(this.data.faces, key)) {
          let element = this.data.faces[key];
          let total = 0;
          for (let key2 in element) {
            if (Object.hasOwnProperty.call(element, key2)) {
              let element2 = element[key2];
              total += element2;
            }
          }
          if (total > busiest.total) {
            busiest.total = total;
            busiest.date = key;
          }
        }
      }
      return busiest;
    },
    busiestHour: function () {
      let busiest = {
        hour: null,
        total: 0,
      };
      for (let key in this.data.faces) {
        if (Object.hasOwnProperty.call(this.data.faces, key)) {
          let element = this.data.faces[key];
          for (let key2 in element) {
            if (Object.hasOwnProperty.call(element, key2)) {
              let element2 = element[key2];
              if (element2 > busiest.total) {
                busiest.total = element2;
                busiest.hour = key2;
              }
            }
          }
        }
      }
      if (busiest.hour) {
        busiest.hour = busiest.hour.replace("_", ":00 - ") + ":00";
      } else {
        busiest.hour = "No data"; 
      }
      return busiest;
    },
    incidentsWithTimeLimit() {
      const fourteenDaysInMillis = 14 * 24 * 60 * 60 * 1000;
      const currentDate = new Date();

      return this.aeincidents.incidents.map((incident) => {
        if (!incident.latest_evidence) {
          return {
            ...incident,
            daysLeft: "Undetermined",
          };
        } else {
          const latestEvidenceDate = new Date(incident.latest_evidence);
          const timeDiff =
            latestEvidenceDate.getTime() +
            fourteenDaysInMillis -
            currentDate.getTime();
          const daysLeft = Math.ceil(timeDiff / (24 * 60 * 60 * 1000));

          return {
            ...incident,
            daysLeft,
          };
        }
      });
    },
    data_heading: function () {
      switch (this.selectedTime) {
        case "day":
          return {
            heading: "dashboard.todays_data",
            day: "dashboard.yesterday",
          };
        case "week":
          return {
            heading: "dashboard.weeks_data",
            day: "dashboard.last_week",
          };
        case "month":
          return {
            heading: "dashboard.months_data",
            day: "dashboard.last_month",
          };
        case "year":
          return {
            heading: "dashboard.years_data",
            day: "dashboard.last_year",
          };
        case "lastyear":
          return {
            heading: "dashboard.last_years_data",
            day: "dashboard.last_year",
          };
      }
    },
    bandingsDateDisplay() {
      const today = DateTime.local();
      switch (this.selectedTime) {
        case "day":
          return `${this.startDate.toFormat("dd MMMM yyyy")}`;
        case "week":
          if (this.timeframeRelative === 0 && 
              this.startDate <= today && 
              this.endDate >= today) {
            return `${this.startDate.toFormat("dd MMMM")} - ${today.toFormat("dd MMMM yyyy")}`;
          } else {
            return `${this.startDate.toFormat("dd MMMM")} - ${this.endDate.toFormat("dd MMMM yyyy")}`;
          }
        case "month":
          if (this.timeframeRelative === 0 && 
              this.startDate.month === today.month && 
              this.startDate.year === today.year) {
            return `${this.startDate.toFormat("dd MMMM")} - ${today.toFormat("dd MMMM yyyy")}`;
          } else {
            return `${this.startDate.toFormat("dd MMMM")} - ${this.endDate.toFormat("dd MMMM yyyy")}`;
          }
        case "year":
          return this.startDate.toFormat("yyyy");
        default:
          return "";
      }
    },
    timeframeDisplay() {
      const today = DateTime.local();
      
      switch (this.selectedTime) {
        case "day":
          return this.timeframeRelative === 0 ? "Today" : `On ${this.startDate.toFormat("dd MMM yyyy")}`;
        case "week":
          if (this.timeframeRelative === 0 && 
              this.startDate <= today && 
              this.endDate >= today) {
            return "This week";
          } else {
            return `Week of ${this.startDate.toFormat("dd MMM yyyy")}`;
          }
        case "month":
          if (this.timeframeRelative === 0 && 
              this.startDate.month === today.month && 
              this.startDate.year === today.year) {
            return "This month";
          } else {
            return this.startDate.toFormat("MMMM yyyy");
          }
        case "year":
          return this.startDate.toFormat("yyyy");
        default:
          return "";
      }
    },
    previousTimeframeRelative() {
      switch (this.selectedTime) {
        case "day":
          return DateTime.local().minus({ days: this.timeframeRelative + 1 }).toFormat("dd/MM/yyyy");
        case "week":
          return DateTime.local().minus({ weeks: this.timeframeRelative + 1 }).startOf('week').toFormat("dd/MM/yyyy") + 
                 ' to ' + DateTime.local().minus({ weeks: this.timeframeRelative + 1 }).endOf('week').toFormat("dd/MM/yyyy");
        case "month":
          return DateTime.local().minus({ months: this.timeframeRelative + 1 }).startOf('month').toFormat("MMMM");
        case "year":
          return DateTime.local().minus({ years: this.timeframeRelative + 1 }).toFormat("yyyy");
        default:
          return "";
      }
    },
    currentTimeframeRelative() {
      switch (this.selectedTime) {
        case "day":
          return DateTime.local().minus({ days: this.timeframeRelative }).toFormat("dd/MM/yyyy");
        case "week":
          return DateTime.local().minus({ weeks: this.timeframeRelative }).startOf('week').toFormat("dd/MM/yyyy") + 
                 ' to ' + DateTime.local().minus({ weeks: this.timeframeRelative }).endOf('week').toFormat("dd/MM/yyyy");
        case "month":
          return DateTime.local().minus({ months: this.timeframeRelative }).startOf('month').toFormat("MMMM");
        case "year":
          return DateTime.local().minus({ years: this.timeframeRelative }).toFormat("yyyy");
        default:
          return "";
      }
    },
    nextTimeframeRelative() {
      switch (this.selectedTime) {
        case "day":
          return DateTime.local().minus({ days: this.timeframeRelative - 1 }).toFormat("dd/MM/yyyy");
        case "week":
          return DateTime.local().minus({ weeks: this.timeframeRelative - 1 }).startOf('week').toFormat("dd/MM/yyyy") + 
                 ' to ' + DateTime.local().minus({ weeks: this.timeframeRelative - 1 }).endOf('week').toFormat("dd/MM/yyyy");
        case "month":
          return DateTime.local().minus({ months: this.timeframeRelative - 1 }).startOf('month').toFormat("MMMM");
        case "year":
          return DateTime.local().minus({ years: this.timeframeRelative - 1 }).toFormat("yyyy");
        default:
          return "";
      }
    }
  },
};
</script>

<style scoped>
.wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 60vh;
}

.sub-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section-heading {
  font-weight: 400;
}
</style>

<style scoped>
@media (max-width: 768px) {
  .form-group.row,
  .form-group.d-flex.row {
    flex-direction: column !important;
    gap: 0 !important;
  }
  .col-xl-6, .col-xl-3 {
    max-width: 100% !important;
    flex: 0 0 100% !important;
    width: 100% !important;
    margin-bottom: 1rem;
  }
  .row {
    flex-direction: column !important;
  }
  .card.widget {
    margin-bottom: 1rem;
    width: 100% !important;
    min-width: 0;
    box-sizing: border-box;
  }
  .widget-stats-container {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .widget-stats-content {
    width: 100%;
    text-align: left;
  }
  .col-4 {
    max-width: 100% !important;
    flex: 0 0 100% !important;
    width: 100% !important;
    margin-bottom: 1rem;
  }
  .table {
    font-size: 0.9rem;
  }
  .btn-group {
    flex-direction: column;
    width: 100%;
  }
  .btn-group .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
</style>
